"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class StagingDatabase extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'stagingDatabase';
        this._status = initParams.status;
        this._date = initParams.date;
    }
    set status(value) {
        console.error('Do not set objects this way');
    }
    setStatus(value) {
        return this.dataService.updateStagingDatabase(this.id, { status: value }, this);
    }
    get status() {
        return this._status;
    }
    set date(value) {
        console.error('Do not set objects this way');
    }
    setDate(value) {
        return this.dataService.updateStagingDatabase(this.id, { date: value }, this);
    }
    get date() {
        return this._date;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateStagingDatabase(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
}
exports.default = StagingDatabase;
//# sourceMappingURL=stagingDatabase.js.map